var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title",class:{
    white: _vm.fontColor === 'white',
    brown: _vm.fontColor === 'brown',
  }},[_c('img',{attrs:{"src":require('@/assets/activityplace/lefthua_' + _vm.fontColor + '.svg')}}),_c('span',[_vm._v(_vm._s(_vm.title))]),_c('img',{attrs:{"src":require('@/assets/activityplace/righthua_' + _vm.fontColor + '.svg')}})])}
var staticRenderFns = []

export { render, staticRenderFns }